module.exports = __webpack_public_path__ + "img/dz-icon.6087eaf9.svg";